<div class="product">
  <div
    class="product-offer"
    tabindex="0"
    aria-label="Ihr Angebot"
    #focusableContent
  >
    <div class="product-offer__header">
      <h5 class="product__title">Ihr Angebot</h5>
      <img
        class="product-offer__logo"
        src="{{ productData.bankProduct.bankDetails.logoUrl }}"
        alt="info"
      />
    </div>
    <div
      class="product__content"
      tabindex="0"
      [attr.aria-label]="'Antragsnummer ' + productData.id"
      #focusableContent
    >
      <p class="content__title">Antragsnummer</p>
      <p class="content__text">{{ productData.id }}</p>
    </div>
    <div
      class="product__content"
      tabindex="0"
      [attr.aria-label]="'Verwendungszweck ' + productData.purpose.name"
      #focusableContent
    >
      <p class="content__title">Verwendungszweck</p>
      <p class="content__text">{{ productData.purpose.name }}</p>
    </div>
    <div
      class="product__content"
      tabindex="0"
      [attr.aria-label]="
        'Gültig bis ' + productData.offerResponse.terms.validUntil
      "
      #focusableContent
    >
      <p class="content__title">Gültig bis</p>
      <p class="content__text">
        {{ productData.offerResponse.terms.validUntil | dateFormat }}
      </p>
    </div>
    <div
      class="product__content"
      tabindex="0"
      [attr.aria-label]="'Kreditvertrag'"
      #focusableContent
    >
      <p class="content__title">Kreditvertrag</p>
      <a
        *ngIf="productData.contractToken"
        class="content__download"
        (click)="onDownloadClick()"
        [class.downloading]="
          downloadStateService.isDownloading(productData.id) | async
        "
      >
        <svg-icon
          *ngIf="!(downloadStateService.isDownloading(productData.id) | async)"
          src="/resultpage/assets/icons/PDF.svg"
          [svgStyle]="{ 'width.px': 25, color: 'var(--primary-color)' }"
          aria-hidden="true"
        />
        <app-spinner
          *ngIf="downloadStateService.isDownloading(productData.id) | async"
          [size]="25"
          className="spinner-primary"
          aria-hidden="true"
        />
        <p>
          {{
            (downloadStateService.isDownloading(productData.id) | async)
              ? "Wird heruntergeladen..."
              : "Herunterladen"
          }}
        </p>
      </a>
      <p *ngIf="!productData.contractToken" class="content__text">
        Kreditvertrag nicht verfügbar
      </p>
    </div>
  </div>
  <div
    class="product_repayment"
    tabindex="0"
    aria-label="Tilgung"
    #focusableContent
  >
    <h5 class="product__title">Tilgung</h5>
    <div class="product__content-bullet">
      <div
        class="content-bullet__bullet"
        *ngIf="
          productData.bankProduct.product.productDetails.additionalServices
            .instalmentBreak.sidebarBullet
        "
        tabindex="0"
        [attr.aria-labelledby]="'instalmentBreak-' + productData.id"
        #focusableContent
      >
        <div class="content-bullet__title">
          <svg-icon
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
            [ngClass]="[
              'checkMark',
              'checkMark_' +
                productData.bankProduct.product.productDetails
                  .additionalServices.instalmentBreak.sidebarBullet.symbolColor
            ]"
            src="{{
              '/resultpage/assets/icons/' +
                productData.bankProduct.product.productDetails
                  .additionalServices.instalmentBreak.sidebarBullet.symbol +
                '.svg'
            }}"
            aria-hidden="true"
          />

          <span [attr.aira-id]="'instalmentBreak-' + productData.id">
            {{
              productData.bankProduct.product.productDetails.additionalServices
                .instalmentBreak.name
            }}
          </span>
        </div>
        <app-hint
          [hintData]="[
            {
              title:
                productData.bankProduct.product.productDetails
                  .additionalServices.instalmentBreak.name,
              text: productData.bankProduct.product.productDetails
                .additionalServices.instalmentBreak.hintForCreditTile
            }
          ]"
        ></app-hint>
      </div>
      <div
        class="content-bullet__bullet"
        *ngIf="
          productData.bankProduct.product.productDetails.additionalServices
            .totalRepayment.sidebarBullet
        "
        tabindex="0"
        [attr.aria-labelledby]="'totalRepayment-' + productData.id"
        #focusableContent
      >
        <div class="content-bullet__title">
          <svg-icon
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
            [ngClass]="[
              'checkMark',
              'checkMark_' +
                productData.bankProduct.product.productDetails
                  .additionalServices.totalRepayment.sidebarBullet.symbolColor
            ]"
            src="{{
              '/resultpage/assets/icons/' +
                productData.bankProduct.product.productDetails
                  .additionalServices.totalRepayment.sidebarBullet.symbol +
                '.svg'
            }}"
            aria-hidden="true"
          />

          <span [attr.aira-id]="'totalRepayment-' + productData.id">
            {{
              productData.bankProduct.product.productDetails.additionalServices
                .totalRepayment.name
            }}
          </span>
        </div>
        <app-hint
          [hintData]="[
            {
              title:
                productData.bankProduct.product.productDetails
                  .additionalServices.totalRepayment.name,
              text: productData.bankProduct.product.productDetails
                .additionalServices.totalRepayment.hintForCreditTile
            }
          ]"
        ></app-hint>
      </div>
      <div
        class="content-bullet__bullet"
        *ngIf="
          productData.bankProduct.product.productDetails.additionalServices
            .unscheduledRepayment.sidebarBullet
        "
        tabindex="0"
        [attr.aria-labelledby]="'unscheduledRepayment-' + productData.id"
        #focusableContent
      >
        <div class="content-bullet__title">
          <svg-icon
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
            [ngClass]="[
              'checkMark',
              'checkMark_' +
                productData.bankProduct.product.productDetails
                  .additionalServices.unscheduledRepayment.sidebarBullet.symbol
            ]"
            src="{{
              '/resultpage/assets/icons/' +
                productData.bankProduct.product.productDetails
                  .additionalServices.unscheduledRepayment.sidebarBullet
                  .symbol +
                '.svg'
            }}"
            aria-hidden="true"
          />

          <span [attr.aira-id]="'unscheduledRepayment-' + productData.id">
            {{
              productData.bankProduct.product.productDetails.additionalServices
                .unscheduledRepayment.name
            }}
          </span>
        </div>
        <app-hint
          [hintData]="[
            {
              title:
                productData.bankProduct.product.productDetails
                  .additionalServices.unscheduledRepayment.name,
              text: productData.bankProduct.product.productDetails
                .additionalServices.unscheduledRepayment.hintForCreditTile
            }
          ]"
        ></app-hint>
      </div>
    </div>
  </div>
</div>
